// extracted by mini-css-extract-plugin
module.exports = {"marginSmall":"1rem","fullWidthFormContainer":"LoginPassword_fullWidthFormContainer__RC-BK","loginButtonsContainer":"LoginPassword_loginButtonsContainer__1YOn8"};